import React, {
  forwardRef,
  type ButtonHTMLAttributes,
  type ReactNode,
  type Ref,
} from 'react';
import { type RequiredProps } from '#/types/utils';
import type { ButtonStyleProps } from '#/component-lib/base-components/styled-buttons';
import { StyledButton } from './styled';

type NativeButtonProps = ButtonHTMLAttributes<HTMLButtonElement>;

interface ButtonProps
  extends ButtonStyleProps,
    RequiredProps<NativeButtonProps, 'onClick' | 'children'> {
  children: NonNullable<ReactNode>;
}

function ButtonInner(
  {
    variant,
    children,
    rounded = false,
    className = undefined,
    ...rest
  }: ButtonProps,
  ref: Ref<HTMLButtonElement>
) {
  return (
    <StyledButton
      variant={variant}
      rounded={rounded}
      className={className}
      ref={ref}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...rest}
    >
      {children}
    </StyledButton>
  );
}

const Button = forwardRef(ButtonInner);
export default Button;
